<template>
     <div class="request-contact-search" :class="{ searching: state === 'searching' }">
        <app-search searchType="contacts" 
            :class="{
                'search__content': true
            }"
            :style="(state === 'searching')?'flex-grow: 1':''"
            :items="hits" 
            :value="value">
            <template v-slot:input>
                <div class="search-content__area">
                    <div class="area__input-box">
                        <div @click="inputFocusButtonClick">
                            <icon name="search" :width="24" :height="24" 
                            :color="(state === 'searching') ? 'var(--font-color--primary)':'var(--font-color)' " style="margin-right: 5px" />
                        </div>
                        <input ref="searchInput" class="new-input_body" @focus="inputFocus()" @blur="inputBlur()"
                        @input="searchByContacts($event.target.value)" :value="value" placeholder="DIGITE PARA PESQUISAR UM CONTATO">
                        <!-- <div @click="cleanSearchField()" style="display: flex; justify-content: center; align-items: center; cursor: pointer; width: 75px; height: 55px;">
                            <button type="button" class="button-clean-search">Limpar</button>
                        </div> -->
                        <a v-if="recording" class="button-record" @click="stopRecording()">
                            <icon color="var(--font-color--primary)" name="mic" width="16" height="16" />
                        </a>
                        <a v-else class="button-record" @click="record()">
                            <icon name="mic" width="16" height="16" />
                        </a>
                        <a style="margin-left: 5px" @click="closeSearch()" v-if="state === 'searching'" class="button-clean-search">
                            <icon name="checkbox-delete-square" width="16" height="16" />
                            cancelar
                        </a>
                    </div>
                    <div class="area__input-line" :class="{ active: state === 'searching' }"></div>
                </div>
                <div v-show="state === 'searching'" class="area__search-priority">
                    Priorizar na busca: 
                    <div class="area__search-priority-item" @click="selectSearchPriority(null)" :class="{ 'selected': searchPriority === null }">
                        <icon style="margin-right: 3px;" 
                            :name="!searchPriority ? 'radio-button-selected' : 'radio-button-unselected'" 
                            :color="searchPriority === null ? '#4D76C8' : '#55595E'"
                        />
                        Combinações
                    </div>
                    <div class="area__search-priority-item" @click="selectSearchPriority('addresses')" :class="{ 'selected': searchPriority === 'addresses' }">
                        <icon style="margin-right: 3px;" 
                            :name="searchPriority === 'addresses' ? 'radio-button-selected' : 'radio-button-unselected'" 
                            :color="searchPriority === 'addresses' ? '#4D76C8' : '#55595E'"
                        />
                        Endereços
                    </div>
                    <div class="area__search-priority-item" @click="selectSearchPriority('complements')" :class="{ 'selected': searchPriority === 'complements' }">
                        <icon style="margin-right: 3px;"  
                            :name="searchPriority === 'complements' ? 'radio-button-selected' : 'radio-button-unselected'" 
                            :color="searchPriority === 'complements' ? '#4D76C8' : '#55595E'"
                        />
                        Complementos
                    </div>
                </div>
            </template>
            <template v-slot:item="slotProps">
                <div
                    style="padding: 0 12px; display: flex; justify-content: space-between; cursor: pointer;"
                    @click="selectSearchContact(slotProps.item)">
                    <div style="display: flex;">
                        <!--<div style="width: 50px; padding: 0 15px 15px 15px; color: white;">{{ slotProps.index + 1 }}</div>-->
                        <div>
                            <div style="margin-bottom: 3px;">
                                <v-highlight highlightClassName="highlight" highlightTag="em" :searchWords="getSearchWords"
                                             :autoEscape="true" :sanitize="sanitizeSearch" :textToHighlight="`${slotProps.item.contact.name} - ${slotProps.item.contact.phone}`" />
                            </div>
                            <div style="display: flex; flex-direction: column">
                                <v-highlight highlightClassName="highlight" highlightTag="em"
                                             :searchWords="value.split(' ')"
                                             :autoEscape="true" :sanitize="sanitizeSearch"
                                             :textToHighlight="`${slotProps.item.contact.address}, ${slotProps.item.contact.number}`" />
                                <v-highlight highlightClassName="highlight" highlightTag="em"
                                             :searchWords="value.split(' ')"
                                             :autoEscape="true" :sanitize="sanitizeSearch"
                                             :textToHighlight="`${slotProps.item.contact.neighborhood}, ${slotProps.item.contact.complement}`" />
                            </div>
                        </div>
                    </div>
                    <!-- <div>
                        {{ slotProps.item.score.toFixed(1) }}
                    </div> -->
                </div>
            </template>
        </app-search>
        <div class="search__result" style="background-color: var(--bg-color--2)" v-if="(state==='searching' && !hits.length) || (state==='searching' && hits[0] && hits[0].score === 0)">
            <div class="new-request__centro">
                <div>
                    <div>
                        <icon-request-search-graf></icon-request-search-graf>
                    </div>
                    <span>Nenhum contato encontrado... <br/> Experimente utilizar outros critérios de busca</span>
                </div>
            </div>
            <div class="new-body__img">
                <icon-request-search-body></icon-request-search-body>
            </div>    
        </div>
    </div>
</template>

<script>
import SearchAPI from '../../../../../api/search'
import ContactAPI from '../../../../../api/contacts'
import shortid from 'shortid'
import { mapActions } from 'vuex';

import SearchComponent from '../../../../../components/Inputs/Search.vue'

export default {
    props: ['request'],
    data(){
        return{
            hits: [],
            value: '',
            searchTimeout: null,
            state: null,
            searchPriority: null,
            recording: false,
            recognition: null
        }
    },
    components: {
        'app-search': SearchComponent
    },
    computed: {
        getSearchWords() {
            if(this.value && this.utils.getNumber(this.value).toString().length >= 7) {
                return this.value.split('')
            }
            return this.value.split(' ')
        }
    },
    methods:{
        ...mapActions("toast", ["showToast", "showError"]),

        inputFocusButtonClick(){
            this.$refs.searchInput.focus()
        },
        inputFocus(){
            if(this.value.trim() !== ""){
                this.searchByContacts(this.value)
            }
        },

        inputBlur(){
/*             if(this.value.trim() === ""){
                this.state = null
            } */
        },

        closeSearch(){
            this.hits = []
            this.state = null
        },

        cleanSearchField() {
            this.value = ''
            this.searchByContacts(this.value)
        },

        sanitizeSearch(text){ 
            return this.utils.removeDiacritics(text)
        },

        selectSearchPriority(priority) {
            if(priority === this.searchPriority)
                return 
            this.searchPriority = priority
            this.searchByContacts(this.value)
        },

        stopRecording(){
            if(this.recording){
                this.recognition.stop()
                this.recording = false
            }
        },

        record(){
            const vm = this
            if (!('webkitSpeechRecognition' in window)) {
                console.log('Web speech API not present')
            }
            else {
                console.log('Initializing....')
                vm.recognition = new webkitSpeechRecognition();
                let final_transcript = ''

                vm.recognition.continuous = true
                vm.recognition.interimResults = true
                vm.recognition.lang = 'pt-BR'
                vm.recognition.start();

                vm.recognition.onstart = function (event) {
                    console.log("I'm listening. Go ahead and speak into the mic.")
                    vm.recording = true
                }

                vm.recognition.onend = function (event) {
                    vm.recording = false
                }

                vm.recognition.onresult = function (event) {
                    let interim_transcript = '';

                    if (typeof (event.results) == 'undefined') {
                        vm.recognition.onend = null;
                        vm.recognition.stop();
                        return;
                    }

                    for (let i = event.resultIndex; i < event.results.length; ++i) {
                        if (event.results[i].isFinal) {
                            final_transcript += event.results[i][0].transcript;
                        } else {
                            interim_transcript += event.results[i][0].transcript;
                        }
                    }

                    if(interim_transcript.trim() === "") return

                    vm.value = interim_transcript
                    vm.searchByContacts(interim_transcript)

                }
            }
        },

        async searchByContacts(value) {
            this.value = value
            if(this.value.trim() === ""){
                this.state = null
                this.hits = []
            }
            else this.state = "searching"
            if(this.searchTimeout) clearTimeout(this.searchTimeout)
            this.searchTimeout = setTimeout(() => {
                SearchAPI.searchContacts(value, { 
                    priority: this.searchPriority
                })
                .then(data => {
                    let hits = data.data.contacts.hits
                    this.hits = this.denormalizeHits(hits)
                    this.request.STATE_request.$update({ where: this.request.STATE_request.id, data: { totalSearch: this.hits.length } })
                    if(this.recording){
                        this.recording = false
                        this.recognition.stop()
                    }
                })
                .catch(err => {
                    this.hits = []
                    this.request.STATE_request.$update({ where: this.request.STATE_request.id, data: { totalSearch: 0 } })
                })
            }, 500)
        },

        denormalizeHits(hits) {
            let denormalizedHits = []
            return _.map(hits, (hit,index) => {
                const hasAddress = hit.source.addresses.length
                const hasPhone = hit.source.phones.length
                return {
                    score: hit.score,
                    contactId: hit.id,
                    contact: {
                        name: hit.source.name,
                        phone: (hasPhone && !_.isEmpty(hit.source.phones[0].number) && !_.isEmpty(hit.source.phones[0].ddd)) ? this.utils.formatPhone(hit.source.phones[0].ddd + hit.source.phones[0].number) : 'S/ TELEFONE',
                        contactPhoneId: (hasPhone && hit.phonesInnerHits && hit.phonesInnerHits.length) ? hit.phonesInnerHits[0]._source.contactPhoneId : null,
                        contactAddressId: (hasPhone && hit.addressesInnerHits && hit.addressesInnerHits.length && hit.addressesInnerHits[0]._score >= 18) ? hit.addressesInnerHits[0]._source.contactAddressId : null,
                        address: (hasAddress && !_.isEmpty(hit.source.addresses[0].address)) ? hit.source.addresses[0].address : 'S/ ENDEREÇO',
                        neighborhood: (hasAddress && !_.isEmpty(hit.source.addresses[0].neighborhood)) ? hit.source.addresses[0].neighborhood : 'S/ BAIRRO',
                        number: (hasAddress && !_.isEmpty(hit.source.addresses[0].number)) ? hit.source.addresses[0].number : 'S/ NÚMERO',
                        complement: (hasAddress && !_.isEmpty(hit.source.addresses[0].complement)) ? hit.source.addresses[0].complement : ''
                    }
                }
            })
        },

        async selectSearchContact(hit) {
            const vm = this
            let contactId = hit.contactId

            vm.request.STATE_request.$update({ 
                where: vm.request.STATE_request.id,
                data: {
                    loading: {
                        show: true,
                        text: 'Adicionando contato no atendimento...'
                    },
                    totalSearch: 0
                }
            })

            let requestOrderTab = 'products'
            try {
                //search in DB contact by id
                const res = await ContactAPI.getRequestHistory(contactId)
                const contact = res.data.contact

                let contactAddressId = null
                let contactPhoneId = null

                if(hit.contact.contactAddressId)
                    contact.contactAddresses.forEach(contactAddress => {
                        if(hit.contact.contactAddressId === contactAddress.id) {
                            contactAddress.isDefault = true
                        }
                        else 
                            contactAddress.isDefault = false
                    })  
                if(hit.contact.contactPhoneId)
                    contact.contactPhones.forEach(contactPhone => {
                        if(hit.contact.contactPhoneId === contactPhone.id) {
                            contactPhone.isDefault = true
                        }
                        else 
                            contactPhone.isDefault = false
                    })  
                
                if(contact.contactAddresses && contact.contactAddresses.length) {
                    let contactAddressDefault = contact.contactAddresses.filter(contactAddress => contactAddress.isDefault)
                    contactAddressId = contactAddressDefault[0] ? contactAddressDefault[0].id : contact.contactAddresses[0].id
                }
                if(contact.contactPhones && contact.contactPhones.length) {
                    let contactPhoneDefault = contact.contactPhones.filter(contactPhone => contactPhone.isDefault)
                    contactPhoneId = contactPhoneDefault[0] ? contactPhoneDefault[0].id : contact.contactPhones[0].id
                }

                //delete, insert new contact and update requestContact with contactId
                vm.request.requestContact.contact.deleteAllInContact()
                vm.request.requestContact.contact.$insert({ data: contact })
                vm.request.requestContact.$update({ 
                    where: vm.request.requestContact.id,
                    data: { 
                        contactId,
                        contactAddressId,
                        contactPhoneId
                    }
                })
    
    
                // clear requestOrder and insert clean requestOrder
                let requestOrderId = vm.request.requestOrderId

                vm.VXORM.RequestOrder.insert({ data: { 
                    id: requestOrderId,
                    promotionChannelId: (() => {
                        if(res.data.list.length) return res.data.list[0].requestOrder.promotionChannelId
                        else return null
                    })() 
                } })
    
                //update request with requestOrderId 
                vm.request.$update({ 
                    where: vm.request.id,
                    data: {
                        requestOrderId
                    }
                })

                vm.request.STATE_request.$update({
                    where: vm.request.STATE_request.id,
                    data: {
                        loadedRequestHistory: true,
                        requestHistory: _.pick(res.data, ['list', 'total'])
                    }
                })

                console.log(this.VXORM.RequestContact.query().where('contactId', contactId).first(), this.VXORM.Contact.find(contactId))
                vm.cleanSearchField()

                if(res.data.list.length) requestOrderTab = 'history'
            } catch(err) {
                this.showError('Algo deu errado.')
            }
             
            vm.request.STATE_request.$update({ 
                where: vm.request.STATE_request.id,
                data: {
                    loading: {
                        show: false,
                        text: null
                    },
                    activeTab: 'order',
                    activeRequestOrderTab: requestOrderTab
                }
            })
        }
    }
}
</script>

<style lang="scss">
    .request-contact-search {
        z-index: 1;
        position: absolute;
        width: 100%;
        top: 0;
        right: 0;
        left: 0;
        flex-direction: column;
        bottom: 0;
        pointer-events: none;
        display: flex;

        &.searching {
            background-color: var(--bg-color--2)
        }

        .search__content {
            min-height: 64px;
            pointer-events: auto; 
            position: relative;
            .search__request {
                display: flex;
                flex-direction: column;
                position: absolute;
                top: 0;
                right: 0;
                left: 0;
                bottom: 0;
            }
        }
        .search__result {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            pointer-events: auto;
        }
        .new-request__centro {
            flex-grow: 1;
        }
        .new-body__img {
            margin: 0 auto;
            padding: 0px 0px;
            height: 156px;
            overflow: hidden;
        }
    }
    .search-content__area{
        display: flex;
        flex-direction: column;
        position: relative;
        .area__input-box {
            display: flex; 
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            border: 2px;
            border-radius: 2px;
            height: 63px;
            padding: 12px;
        }
        .area__input-line {
            height: 2px;
            margin: 0 12px;
            background: #23272B;
            position: absolute;
            bottom: 12px;
            right: 0;
            left: 0;
            &.active {
                background: linear-gradient(180.36deg, #49DFEA -10.02%, #594BC8 91.15%);
            }
        }
        input {
            outline: 0;
            text-transform: uppercase;
            margin: 0;
            padding: 0;
        }
    }
    .new-input_body{
        border: 0px;
        background: transparent;
        width: 100%;
        height: 50px;
        margin-top: -10px;
        margin-bottom: -10px;
        padding-left: 5px;
        padding-right: 0;
        font-size: 14px;
        color: #73777B;
    }
    .new-request__centro div{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 15px 0px 25px 0px;
    }
    .new-request__centro div span{
        text-align: center;
        font-size: 14px;
        margin-top: 10px;
    }

    .new-body__img {
        margin: 0 auto;
    }

    .button-record {
        display: flex;
        flex-direction: row;
        padding: 3px 12px;
        background: var(--bg-color);
        border: none;
        font-size: 14px;
        color: var(--font-color);
        outline: 0;
        align-items: center;
        border-radius: 12px;
        cursor: pointer;
        font-weight: 300;
        position: relative;
        top: -2px;
    }

    .button-clean-search {
        display: flex;
        flex-direction: row;
        padding: 3px 12px;
        background: var(--bg-color);
        border: none;
        font-size: 14px;
        color: var(--font-color);
        outline: 0;
        align-items: center;
        border-radius: 12px;
        cursor: pointer;
        font-weight: 300;
        position: relative;
        top: -2px;
        div {
            margin-right: 5px;
        }
    }

    .area__search-priority {
        display: flex;
        // justify-content: space-between;
        align-items: center;
        height: 25px;
        color: #4D76C8;
        font-size: .9em;
        padding: 0px 11px 11px;

        .selected {
            color: white;
        }
    }

    .area__search-priority-item {
        display: flex; 
        align-items: center;
        margin-left: 15px;
        cursor: pointer;
    }

</style>
